import { hasPermission } from "@/modules/rbac/permission-manifest";

const associateQuickActions = (associate) => {
  return [
    {
      text: "Order",
      event: "navigate",
      params: {
        path: "AssociateCreateOrder",
      },
      visible: hasPermission("canCreateOrder", null, associate),
    },
    {
      text: "Customer",
      event: "navigate",
      params: {
        path: "AddCustomer",
      },
      visible: hasPermission("canCreateCustomer", null, associate),
    },
    {
      text: "User",
      event: "open-modal",
      params: {
        modal: "userModal",
      },
      visible: hasPermission("canInviteUser", null, associate),
    },
    {
      text: "Associate",
      event: "open-modal",
      params: {
        modal: "inviteAssociateModal",
      },
      visible: hasPermission("canInviteAssociate", null, associate),
    },
    {
      text: "Template",
      event: "navigate",
      params: {
        path: "AssociateCreateTemplate",
      },
      visible: true,
    },
    {
      text: "Product",
      event: "navigate",
      params: {
        path: "AddProduct",
      },
      visible: hasPermission("canCreateProduct", null, associate),
    },
    {
      text: "Distributor",
      event: "navigate",
      params: {
        path: "AddDistributor",
      },
      visible: hasPermission("canCreateDistributor", null, associate),
    },
  ];
};

const userQuickActions = (user) => {
  return [
    {
      text: "Order",
      event: "navigate",
      params: {
        path: "UserCreateOrder",
      },
      visible: hasPermission("canCreateOrder", null, user),
    },
    {
      text: "Order Template",
      event: "navigate",
      params: {
        path: "UserCreateTemplate",
      },
      visible: true,
    },
  ];
};

export { associateQuickActions, userQuickActions };
